module.exports = "<div class=\"wrapper\">\n    <ui-view></ui-view>\n</div>\n<ng2-toasty [position]=\"'top-right'\"></ng2-toasty>\n"